/**
 * Board page content. Each role/committee is data-driven so real member
 * photos, names, and descriptions can be dropped in here later without
 * touching any layout/CSS. `members[].photo` stays `null` until a real
 * photo is supplied — RoleBlock renders a placeholder frame in that case.
 */

// Executive board
import presidentPoster from "../../../pictures/ExecutiveBoard/President/President.jpg";
import presidentMember from "../../../pictures/ExecutiveBoard/President/Ryan-Dela-Cruz.jpg";
import ivpPoster from "../../../pictures/ExecutiveBoard/IVP/IVP.jpg";
import ivpMember from "../../../pictures/ExecutiveBoard/IVP/Julia-Foronda.jpg";
import evpPoster from "../../../pictures/ExecutiveBoard/EVP/EVP.jpg";
import evpMember from "../../../pictures/ExecutiveBoard/EVP/Hayden-Macaraeg.jpg";
import secretaryPoster from "../../../pictures/ExecutiveBoard/Secretary/Secretary.jpg";
import secretaryMember from "../../../pictures/ExecutiveBoard/Secretary/Thea-Flamiano.jpg";
import treasurerPoster from "../../../pictures/ExecutiveBoard/Treasurer/Treasurer.jpg";
import treasurerMember from "../../../pictures/ExecutiveBoard/Treasurer/Marly-Diemsen.jpg";

// Officer board
import historianPoster from "../../../pictures/OfficerBoard/Historian/historian.jpg";
import historianMember1 from "../../../pictures/OfficerBoard/Historian/Cadence-Amorino.jpg";
import historianMember2 from "../../../pictures/OfficerBoard/Historian/Joey-Chavez.jpg";

import d7Poster from "../../../pictures/OfficerBoard/D7/D7.jpg";
import d7Member1 from "../../../pictures/OfficerBoard/D7/Ariston-Redel.jpg";
import d7Member2 from "../../../pictures/OfficerBoard/D7/Sherwin-Buquid.jpg";

import culturePoster from "../../../pictures/OfficerBoard/Culture/Culture.jpg";
import cultureMember1 from "../../../pictures/OfficerBoard/Culture/Haille-Le.jpg";
import cultureMember2 from "../../../pictures/OfficerBoard/Culture/Jasmine-Dizon.jpg";
import cultureMember3 from "../../../pictures/OfficerBoard/Culture/Xander-Tabadero.jpg";

import eventsPoster from "../../../pictures/OfficerBoard/Events/Events.jpg";
import eventsMember1 from "../../../pictures/OfficerBoard/Events/Ajdin-Harbas.jpg";
import eventsMember2 from "../../../pictures/OfficerBoard/Events/Audrey-Gene-Riel.jpg";
import eventsMember3 from "../../../pictures/OfficerBoard/Events/Nathan-Chan.jpg";

import fundraisingPoster from "../../../pictures/OfficerBoard/Fundraising/Fundraising.jpg";
import fundraisingMember1 from "../../../pictures/OfficerBoard/Fundraising/Caley-Byles.jpg";
import fundraisingMember2 from "../../../pictures/OfficerBoard/Fundraising/Gillian-Gutierrez.jpg";

import hospitalityPoster from "../../../pictures/OfficerBoard/Hospitality/Hospitality.jpg";
import hospitalityMember1 from "../../../pictures/OfficerBoard/Hospitality/Bianca-Rivera.jpg";
import hospitalityMember2 from "../../../pictures/OfficerBoard/Hospitality/Janis-Lingat.jpg";

import promotionsPoster from "../../../pictures/OfficerBoard/Promotions/Promotions.jpg";
import promotionsMember1 from "../../../pictures/OfficerBoard/Promotions/Johanna-Shin.jpg";
import promotionsMember2 from "../../../pictures/OfficerBoard/Promotions/Keira-Balasabas.jpg";
import promotionsMember3 from "../../../pictures/OfficerBoard/Promotions/Rachel-Kuang.jpg";

import servicePoster from "../../../pictures/OfficerBoard/Service/Service.jpg";
import serviceMember1 from "../../../pictures/OfficerBoard/Service/Cruz-Maralit.jpg";
import serviceMember2 from "../../../pictures/OfficerBoard/Service/Johanna-Fontanilla.jpg";
import serviceMember3 from "../../../pictures/OfficerBoard/Service/Kenyon-Tran-Muñoz.jpg";

import sportsPoster from "../../../pictures/OfficerBoard/Sports/Sports.jpg";
import sportsMember1 from "../../../pictures/OfficerBoard/Sports/Alex-Fowler.jpg";
import sportsMember2 from "../../../pictures/OfficerBoard/Sports/Khoa-Dinh.jpg";
import sportsMember3 from "../../../pictures/OfficerBoard/Sports/Luke-Pineda.jpg";

import videographerPoster from "../../../pictures/OfficerBoard/Videographer/Videographer.jpg";
import videographerMember1 from "../../../pictures/OfficerBoard/Videographer/Tyler-Valdez.jpg";

import webmasterPoster from "../../../pictures/OfficerBoard/Webmaster/Webmaster.jpg";
import webmasterMember1 from "../../../pictures/OfficerBoard/Webmaster/Nam-Hoang.jpg";
import webmasterMember2 from "../../../pictures/OfficerBoard/Webmaster/Tyler-Reotutar.jpg";

import seniorAdvisorsPoster from "../../../pictures/OfficerBoard/Senior-Advisors/Senior-Advisors.jpg";
import seniorAdvisorsMember1 from "../../../pictures/OfficerBoard/Senior-Advisors/Jason-Valdez.jpg";
import seniorAdvisorsMember2 from "../../../pictures/OfficerBoard/Senior-Advisors/Javier-Maca.jpg";
import seniorAdvisorsMember3 from "../../../pictures/OfficerBoard/Senior-Advisors/Rennecy-Reyes.jpg";

export const execRoles = [
  {
    id: "president",
    title: "President",
    posterImage: presidentPoster,
    members: [{ name: "Ryan Dela Cruz", photo: presidentMember }],
    description: "The President presides and oversees the FASA Executive Board, Officer, and General Body Meetings, serves as a representative on the Asian-American Student Union Council, and executes evaluations of officers.",
  },
  {
    id: "internal-vp",
    title: "Internal Vice President",
    posterImage: ivpPoster,
    members: [{ name: "Julia Foronda", photo: ivpMember }],
    description: "The Internal Vice President is responsible for taking on the responsibilities in the absence of the President, serving along the President and External Vice President, and serving as Culture Show coordinator.",
  },
  {
    id: "external-vp",
    title: "External Vice President",
    posterImage: evpPoster,
    members: [{ name: "Hayden Macaraeg", photo: evpMember }],
    description: "The External Vice President is responsible for taking on responsibilities in absence of the President, serving as the prime representative on the Asian-American Student Union Council, and update the Executive Board.",
  },
  {
    id: "secretary",
    title: "Secretary",
    posterImage: secretaryPoster,
    members: [{ name: "Thea Flamiano", photo: secretaryMember }],
    description: "The Secretary is responsible for keeping records of buisiness carried at general, officer, executive board, and special meetings, maintaining and updating the FASA newsletter, and correspondence with outside relations.",
  },
  {
    id: "treasurer",
    title: "Treasurer",
    posterImage: treasurerPoster,
    members: [{ name: "Marly Diemsen", photo: treasurerMember }],
    description: "The Treasurer is responsible for keeping all financial records of the organization, reviewing all monthly financial accounts and budgets, witholding the FASA debit card, and obtaining a bank account for FASA.",
  },
];

export const officerCommittees = [
  {
    id: "historians",
    title: "Historians",
    posterImage: historianPoster,
    members: [
      { name: "Cadence Amorino", photo: historianMember1 },
      { name: "Joey Chavez", photo: historianMember2 },
    ],
    description: "The Historians are responsible for keeping record of activities and events of the organization on social media, and taking pictures and videos of Official FASA Events and other organizational affairs.",
  },
  {
    id: "d7-representatives",
    title: "D7 Representatives",
    posterImage: d7Poster,
    members: [
      { name: "Ariston Redel", photo: d7Member1 },
      { name: "Sherwin Buquid", photo: d7Member2 },
    ],
    description: "The District 7 Representatives are responsible for gathering the necessary infomration for upcoming D7 events and organizing transportation and registration for intercollegiate events including D7 Olympics.",
  },
  {
    id: "culture",
    title: "Culture",
    posterImage: culturePoster,
    members: [
      { name: "Haille Le", photo: cultureMember1 },
      { name: "Jasmine Dizon", photo: cultureMember2 },
      { name: "Xander Tabadero", photo: cultureMember3 },
    ],
    description: "The Culture Committee is responsible for educating the members of FASA and the Virginia Tech community, working to make culturally relevant itinerary for events, and administrate the @fasa_eats account.",
  },
  {
    id: "events",
    title: "Events",
    posterImage: eventsPoster,
    members: [
      { name: "Ajdin Harbas", photo: eventsMember1 },
      { name: "Audrey Gene Riel", photo: eventsMember2 },
      { name: "Nathan Chan", photo: eventsMember3 },
    ],
    description: "The Events Committee is responsible for planning major events within the organization and between other organizations within Virginia Tech, and updating the officer board on projects and activities.",
  },
  {
    id: "fundraising",
    title: "Fundraising",
    posterImage: fundraisingPoster,
    members: [
      { name: "Caley Byles", photo: fundraisingMember1 },
      { name: "Gillian Gutierrez", photo: fundraisingMember2 },
    ],
    description: "The Fundraising Committee is responsible for organizing and controlling fundraisers that include Virginia Tech Football Concessions, Restaurant Fundraisers, International Street Fair, and more!",
  },
  {
    id: "hospitality",
    title: "Hospitality",
    posterImage: hospitalityPoster,
    members: [
      { name: "Bianca Rivera", photo: hospitalityMember1 },
      { name: "Janis Lingat", photo: hospitalityMember2 },
    ],
    description: "The Hospitality Committee is responsible for introducing and continuing relations with new/old FASA members, enthusiastically introduce the Ate/Kuya Program, and unite members!",
  },
  {
    id: "promotions",
    title: "Promotions",
    posterImage: promotionsPoster,
    members: [
      { name: "Johanna Shin", photo: promotionsMember1 },
      { name: "Keira Balasabas", photo: promotionsMember2 },
      { name: "Rachel Kuang", photo: promotionsMember3 },
    ],
    description: "The Promotions Committee is responsible for informing the community of all organization activities, maintaining all forms of advertisement, and maintaining FASA's social media pages alongside the Secretary.",
  },
  {
    id: "service",
    title: "Service",
    posterImage: servicePoster,
    members: [
      { name: "Cruz Maralit", photo: serviceMember1 },
      { name: "Johanna Fontanilla", photo: serviceMember2 },
      { name: "Kenyon Tran Muñoz", photo: serviceMember3 },
    ],
    description: "The Service Committee is responsible for major service events for the organization, which include FASA Thrifts, Relay For Life, The Big Event, Charity Ball, GBM Theme Fundrasiers, and more!",
  },
  {
    id: "sports",
    title: "Sports",
    posterImage: sportsPoster,
    members: [
      { name: "Alex Fowler", photo: sportsMember1 },
      { name: "Khoa Dinh", photo: sportsMember2 },
      { name: "Luke Pineda", photo: sportsMember3 },
    ],
    description: "The Sports Committee is responsible for organizing all sporting events, deciding on intramurals FASA will participate in, organizing practice schedules as necessary, and recruiting players.",
  },
  {
    id: "videographer",
    title: "Videographer",
    posterImage: videographerPoster,
    members: [{ name: "Tyler Valdez", photo: videographerMember1 }],
    description: "The Videographer is responsible for recording, editing, and condensing video footage of all major organizational events, and having creative autonomy to create video conent relevant to FASA's purpose.",
  },
  {
    id: "webmasters",
    title: "Webmasters",
    posterImage: webmasterPoster,
    members: [
      { name: "Nam Hoang", photo: webmasterMember1 },
      { name: "Tyler Reotutar", photo: webmasterMember2 },
    ],
    description: "The Webmasters are responsible for maintaining FASA's online web page, updating the website of the upcoming officer board, and working with the Execuitve Board to update members through the website.",
  },
  {
    id: "senior-advisors",
    title: "Senior Advisors",
    posterImage: seniorAdvisorsPoster,
    members: [
      { name: "Jason Valdez", photo: seniorAdvisorsMember1 },
      { name: "Javier Maca", photo: seniorAdvisorsMember2 },
      { name: "Rennecy Reyes", photo: seniorAdvisorsMember3 },
    ],
    description: "The Senior Advisors are responsible for offering advice to members of the Executive Board and Officer Board and sharing their wisdom with incoming new officers and members.",
  },
];
